import React from 'react'
import { Svg, ga } from '../../application'
import { colors } from './../../styles'
import styled from 'react-emotion'

export const LinkWithRoundIcon = styled('a')`
  display: inline-flex;      
  margin-right: 20px;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
  svg.pictogram {
    margin-right: 5px;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    padding: 5px;
    color: ${colors.tui_white};
    background-color: ${colors.tui_link_blue};
  }
`

export default ({ icon, action, href, text, tracking }) => {
  const events = {
    onClick: () => {
      if (tracking)
        ga.buttonClick(tracking)
      if (action)
        action()
    }
  }

  const props = href
    ? { ...events, href, target: '_blank' }
    : events

  return (
    <LinkWithRoundIcon {...props}>
      <Svg icon={icon} />
      {text}
    </LinkWithRoundIcon>
  )
}
